<ion-app *ngIf="appLoaded">
  <ion-router-outlet></ion-router-outlet>
</ion-app>